import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";
import {
  Table,
  Tooltip,
  Tag,
  Input,
  Button,
  Space,
  message,
  Drawer,
  Modal,
  Statistic,
  Row,
  Col,
  Typography,
  List,
  Descriptions,
  Select,
  DatePicker,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./styles.scss";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { Column } from "@ant-design/plots";
import MainPie from "../../analytics/MainPie";

import LineTime from "../../analytics/LineTime";
import ColumnTime from "../../analytics/ColumnTime";
import ColumnGroupTime from "../../analytics/ColumnGroupTime";
import ColumnStackedTime from "../../analytics/ColumnStackedTime";

import { numberWithCommas } from "../../../utils/helpers";

import { fixbrockenpackages } from "../../../Redux/actions/packageActions";
import { getProductInventoryofBranch } from "../../../Redux/actions/inventoryActions";
import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../../Redux/actions/exchangerateActions";
import InventoryItem from "../InventoryItem";
import AssetValueExport from "../exports/AssetValueExport";

const { Title } = Typography;

const Index = ({ maindata, datePickerValue }) => {
  const dispatch = useDispatch();

  const { crudData, crudDataCount, locations, user, currentProps } =
    useSelector(
      (state) => ({
        user: state.auth.user,
        crudData: state.analytics.data,
        crudDataCount: state.analytics.dataCount,
        locations: state.locations.locations,
        currentProps: state.analytics.currentProps,
      }),
      shallowEqual
    );

  const { Option } = Select;

  const [categoryFilter, setCategoryFilter] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({});

  const [currentLocation, setCurrentLocation] = useState({});
  const [currentLocationDetails, setCurrentLocationDetails] = useState({});

  const [loading, setLoading] = useState(false);

  const [inventoryData, setinventoryData] = useState([]);
  const [assetData, setAssetData] = useState([]);

  const [currentWeighted, setCurrentWeighted] = useState(0);

  const [currentTotal, setCurrentTotal] = useState(0);

  useEffect(() => {
    getcurrentrate();
  }, []);

  // useEffect(() => {
  //   console.log(assetData)

  // }, [assetData])

  const getcurrentrate = async () => {
    var currentaverage = await dispatch(getWeightedExchangeRate());
    if (currentaverage) {
      setCurrentWeighted(currentaverage.value.toFixed(2));
    }
  };

  useEffect(() => {
    if (locations) {
      if (locations?.[0]) {
        console.log(locations);
        setCurrentLocation(locations[0].id);
      }
    }
  }, [locations]);

  useEffect(() => {
    if (currentLocation) {
      setCurrentTotal(0);
      setAssetData([]);
      setinventoryData([]);
      gettheinventoryitems(currentLocation);
      var loc_details = locations.filter((loc) => loc.id == currentLocation);
      if (loc_details?.[0]) {
        setCurrentLocationDetails(loc_details[0]);
      }
    }
  }, [currentLocation, datePickerValue]);

  const gettheinventoryitems = async (locid) => {
    dispatch(getProductInventoryofBranch(locid))
      .then((res) => {
        var docs = res.docs;
        var dataArray = [];

        docs.map((item) => {
          var newOrder = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };
          dataArray.push(newOrder);
        });
        console.log("gettheinventoryitems: ", dataArray);
        setinventoryData(dataArray);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (locations && maindata && currentProps) {
      if (currentProps.apiurl == "inventory") {
        console.log(locations);
      }
    }
  }, [maindata, locations]);

  useEffect(() => {
    // console.log(selectedCategory)
    // console.log(categoryFilter)
  }, [categoryFilter, selectedCategory]);

  const addtoAssetData = (datum) => {
    var newdata = [...assetData, datum];
    setAssetData(newdata);
  };

  return (
    <div className="analytics_locations_inventory_container">
      <div className="titlerow fullwidth">
        <Select
          value={currentLocation}
          onChange={(val, option) => {
            setCurrentLocation(val);
          }}
          loading={loading}
          placeholder={"branch "}
          className={"selectwidth"}
        >
          {locations.map((loc) => {
            return <Option value={loc.id}>{loc.name}</Option>;
          })}
        </Select>

        <div>
          TOTAL ASSET VALUE PHP: {numberWithCommas(currentTotal.toFixed(2))}
        </div>
        <AssetValueExport
          values={assetData}
          datePickerValue={datePickerValue}
          name={""}
          currentLocationDetails={currentLocationDetails}
        />
      </div>
      <div className="column">
        {inventoryData.map((inven) => {
          if (inven.product) {
            return (
              <InventoryItem
                datePickerValue={datePickerValue}
                product_ID={inven.product}
                prod_inventory={inven}
                exchagerate={currentWeighted}
                onValueComputed={(val) => {
                  setCurrentTotal(val.value + currentTotal);
                  addtoAssetData(val);
                }}
                currentLocationDetails={currentLocationDetails}
              ></InventoryItem>
            );
          }
        })}
      </div>
    </div>
  );
};

export default Index;
